<template>
    <v-card
        color="#fafafa"
        class="elevation-6 white d-flex justify-center align-center flex-column table-min-height pa-4" 
        >
        <img :src="getImgUrl(img)" alt="">
        <span class="title light-blue--text text--darken-4 font-weight-bold text-center">{{ title }}</span>
        <span class="body-1 grey--text text--darken-1 mt-2 text-center">
            {{ text }}
        </span>
    </v-card>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: 'Ops! Não encontramos nada por aqui.',
            require: false
        },
        text: {
            type: String,
            default: 'Não há valores a serem exibidos',
            require: false
        },
        img: {
            type: String,
            default: 'empty-channels.svg',
            require: false
        }
    },
    methods: {
        getImgUrl(pic) {
            return require('../assets/empty/' + pic)
        }
    }
}
</script>

<style>

</style>